import getClient from 'utilities/startplusGraphql';
import { Mutations } from 'apollo';
import { getExtension } from 'utilities/fileHandlingHelpers';
import Logger from 'utilities/logger';

const uploadMyFile = async (document, onDone) => {
  const logger = Logger('MyFiles.uploadMyFile');
  let newDoc;
  const extension = getExtension(document.file.name);
  const contentType =
    extension === 'pdf' ? 'application/pdf' : `image/${extension}`;

  const reader = new FileReader();
  reader.readAsDataURL(document.file);
  reader.onload = async () => {
    const variables = {
      category: document.category,
      file: reader.result,
      name: document.file.name,
      contentType: contentType,
    };
    // Upload file and handle response
    try {
      const startPlusClient = await getClient();
      const response = await startPlusClient.mutate({
        mutation: Mutations.uploadMyFile,
        variables,
      });
      const { data } = response;
      const { uploadMyFile } = data;
      newDoc = {
        file: document.file,
        state: 'SUCCESS',
        myFile: uploadMyFile,
      };
    } catch (error) {
      logger.error(error);
      newDoc = {
        file: document.file,
        state: 'ERROR',
      };
    }
    onDone({ [document.file.name]: newDoc });
  };
};

export default uploadMyFile;
